
















import { PrescricaoParmDTO, PrescriptionDraftItemList } from '@/interfaces/prescription';
import * as service from '@/services/prescription-draft';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import PrescriptionDraftListDialog from './prescription-draft-list-dialog.vue';

@Component({
  components: {
    PrescriptionDraftListDialog
  }
})
export default class PrescriptionDraft extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  prescriptionSaved: boolean;

  flagShowDraftListDialog = false;
  draftList = [];

  show = false;

  run = false;
  draftId = null;
  saveRunning = false;
  intervalSave = null;
  loadRunning = false;
  intervalLoad = null;

  idUser = null;
  idBusinessUnit = null;
  idClientUnit = null;

  mounted() {
    this.loadDraftList();

    this.intervalSave = setInterval(() => {
      this.saveDraft();
    }, 10000);

    this.intervalLoad = setInterval(() => {
      this.loadDraftList();
    }, 60000);
  }

  loadDraftList() {
    if (this.loadRunning) {
      return;
    }
    this.loadRunning = true;
    service.listPrescriptionsDrafts().subscribe(
      (res) => {
        if (this.draftId) {
          this.draftList = res.filter((i) => i.id != this.draftId);
        } else {
          this.draftList = res;
        }
        this.loadRunning = false;
      },
      (error) => {
        this.loadRunning = false;
      }
    );
  }

  saveDraft() {
    if (this.saveRunning) {
      return;
    }
    if (!this.run || !this.item || !this.item.paciente || !this.item.paciente.id) {
      return;
    }
    let rasc = new PrescricaoParmDTO();
    rasc.load(this.item);

    this.saveRunning = true;
    let obs = null;
    if (this.draftId) {
      obs = service.updatePrescriptionDraft(this.draftId, rasc);
    } else {
      obs = service.savePrescriptionDraft(rasc);
    }

    obs.subscribe(
      (res) => {
        this.draftId = res;
        this.saveRunning = false;
      },
      (error) => {
        this.draftId = null;
        this.saveRunning = false;
      }
    );
  }

  loadDraft(item: PrescriptionDraftItemList) {
    service.getPrescriptionDraft(item.id).subscribe(
      (res) => {
        this.$emit('loadDraft', res);
        this.deleteDraftById(item.id);
      },
      (error) => {
        this.loadDraftList();
      }
    );
    this.closeListDialog();
  }

  deleteDraft(item: PrescriptionDraftItemList) {
    this.deleteDraftById(item.id);
  }

  deleteDraftById(id) {
    this.loader.start();
    service.deletePrescriptionDraft(id).subscribe(
      (res) => {
        this.loader.stop();
        this.loadDraftList();
      },
      (error) => {
        this.loader.stop();
      }
    );
  }

  beforeDestroy() {
    clearInterval(this.intervalSave);
    clearInterval(this.intervalLoad);
  }

  showListDialog() {
    this.flagShowDraftListDialog = true;
  }

  closeListDialog() {
    this.flagShowDraftListDialog = false;
  }

  @Watch('prescriptionSaved')
  onChangePrescriptionSaved(prescriptionSaved) {
    if (!prescriptionSaved) {
      return;
    }
    this.deleteDraftById(this.draftId);
    this.draftId = null;
    this.run = false;
  }

  @Watch('item.paciente.id')
  onChangePatientId(idPaciente) {
    if (idPaciente == null) {
      return;
    }
    this.run = true;
  }
}
